/**
 * The tabs of an open Run, in display order. The tab is kept in the URL
 * (`?Tab=`), so this list is also the set of accepted values.
 */
export type CapacityPlanTab = 'deliveries' | 'result' | 'settings';

export const capacityPlanTabs: CapacityPlanTab[] = [
  'deliveries',
  'result',
  'settings',
];

export const defaultCapacityPlanTab: CapacityPlanTab = 'deliveries';
